/**
 * Inventory capability keys — the EXACT server capability strings (server/src/modules/inventory,
 * server/src/config/rbac.config.js, role MAGASINIER). useCan / nav gating / ProtectedRoute all key
 * off these. The server re-checks every request; these only hide/disable UI (never the trust boundary).
 */
export const INV_CAPS = {
  reactifRead: "inventory.reactif.read",
  reactifCreate: "inventory.reactif.create",
  reactifUpdate: "inventory.reactif.update",
  lotReceive: "inventory.lot.receive",
  lotRead: "inventory.lot.read",
  /** The ledger writer — also gates lot quarantine/release + the expiry sweep. */
  mouvementCreate: "inventory.mouvement.create",
  recetteManage: "inventory.recette.manage",
  chargeSet: "inventory.charge.set",
  recallRun: "inventory.recall.run",
  /** Cycle-count (INV-8) — open/count/review/post/cancel an inventory session. */
  inventaireRun: "inventory.inventaire.run",
} as const;

export type InventoryCapability = (typeof INV_CAPS)[keyof typeof INV_CAPS];
